<script context="module">
    import { fetchWithHeaders, getBaseURL } from "../utils.svelte";

    export async function getUSDExchangeRate() {
        const apiResp = await fetchWithHeaders(getBaseURL() + "/system/usd-exchange-rate");
        return apiResp;
    }
</script>
